import { Component, OnInit } from '@angular/core';
import {StsNotification} from '../../../models/sts-notification.model';

@Component({
  selector: 'app-account-help',
  templateUrl: './account-help.component.html',
  styleUrls: ['./account-help.component.scss']
})
export class AccountHelpComponent implements OnInit {


  public errors: StsNotification[] = [];

  constructor() { }

  ngOnInit() {
  }

}
